<template>
  <div style="position: relative" :style="buttonStyle">
    <div class="laptop-frame">
      <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s" />
    </div>
    <div class="laptop-body" style="font-family: inherit">
      <div class="header-mob">
        <div class="app-logo">
         <img
  :src="appIcon || 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s'"
  alt="Logo"
/>
          <div>
            <div class="app-name">
              {{ appName }}
            </div>
            <div class="tag-line">{{ tagLine }}</div>
          </div>
        </div>
        <div class="search-bar">
          <input type="text" placeholder="Search For Beauty Products...💄" />
          <button>
            <i class="fa fa-search"></i>
          </button>
        </div>
        <ul class="headerUl">
          <li v-if="headerWishlistIcon">
            <i class="fas fa-heart"><span class="icon-gap">Wishlist</span></i>
          </li>
          <li v-if="headerCartIcon">
            <i class="fas fa-shopping-cart icon-gap"
              ><span class="icon-gap">Cart</span></i
            >
          </li>
          <li>
            <i class="fas fa-user icon-gap"
              ><span class="icon-gap">Sign In</span></i
            >
          </li>
        </ul>
      </div>
      <div class="body-mob" :style="`color:${primaryTextColor};`">
        <div
          :style="`background: linear-gradient(135deg, ${statusBar} 0%, ${headerTop} 99.99%); color:${primaryTextColor};`"
        >
          <div class="mid-banner">
            <img
              class="banner-img"
              src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s"
              alt="beauty products"
            />
          </div>
        </div>
        <section class="category-section">
          <!-- Heading -->
          <div class="section-header">
            <h2>Discover Your Perfect Match</h2>
            <p>Explore our curated beauty collections</p>
          </div>

          <!-- Category Grid -->
          <div class="category-grid">
            <div
              v-for="(category, index) in categories"
              :key="index"
              class="category-card"
            >
              <!-- Top Icon + Gradient -->
              <div class="card-top">
                <span class="card-icon">🛍️</span>
                <img :src="category.image" alt="category image" />
              </div>

              <!-- Content -->
              <div class="card-content">
                <h3>{{ category.title }}</h3>
                <p>{{ category.desc }}</p>
                <a href="#" class="shop-link">Shop Now →</a>
              </div>
            </div>
          </div>
        </section>
        <div class="trending-section">
          <!-- Header -->
          <div class="trending-header">
            <div>
              <span class="badge">🔥 TRENDING</span>
              <h2>Beauty Bestsellers</h2>
              <p>What everyone's loving right now</p>
            </div>
            <div>
              <button class="view-all">View All Trends →</button>
            </div>
          </div>

          <!-- Product Grid -->
          <div class="product-grid">
            <div
              class="product-card"
              v-for="(product, index) in products"
              :key="index"
            >
              <!-- Discount Badge -->
              <span v-if="product.discount" class="discount-badge">
                {{ product.discount }}% OFF
              </span>

              <!-- Action Buttons -->
              <div class="actions">
                <button class="circle-btn white">
                  <i class="fa fa-heart"></i>
                </button>
                <button class="circle-btn green">
                  <i class="fa fa-eye"></i>
                </button>
              </div>

              <!-- Image -->
              <div class="product-image">
                <img :src="product.image" :alt="product.name" />
              </div>

              <!-- Info -->
              <div class="product-info">
                <h3>{{ product.name }}</h3>
                <span class="brand">{{ product.brand }}</span>
                <div class="price">
                  <span v-if="product.oldPrice" class="old-price"
                    >${{ product.oldPrice }}</span
                  >
                  <span class="new-price">${{ product.price }}</span>
                </div>
                <button class="add-to-bag">ADD TO BAG</button>
              </div>
            </div>
          </div>
        </div>
        <div class="mid-banner">
          <img
            src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s"
            alt="beauty banner"
          />
        </div>
        <div class="trending-section">
          <!-- Header -->
          <div class="favorite-brands">
            <h2>Shop by Favorite Brands</h2>
          </div>

          <!-- Product Grid -->
          <div class="product-grid">
            <div
              class="product-card"
              v-for="(product, index) in products"
              :key="index"
            >
              <!-- Discount Badge -->
              <span v-if="product.discount" class="discount-badge">
                {{ product.discount }}% OFF
              </span>

              <!-- Action Buttons -->
              <div class="actions">
                <button class="circle-btn white">
                  <i class="fa fa-heart"></i>
                </button>
                <button class="circle-btn green">
                  <i class="fa fa-eye"></i>
                </button>
              </div>

              <!-- Image -->
              <div class="product-image">
                <img :src="product.image" :alt="product.name" />
              </div>

              <!-- Info -->
              <div class="product-info">
                <h3>{{ product.name }}</h3>
                <span class="brand">{{ product.brand }}</span>
                <div class="price">
                  <span v-if="product.oldPrice" class="old-price"
                    >${{ product.oldPrice }}</span
                  >
                  <span class="new-price">${{ product.price }}</span>
                </div>
                <button class="add-to-bag">ADD TO BAG</button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        class="mt-2"
        :style="`background: ${footerBgColor}; color: ${footerTextColor}`"
      >
        <div class="footer-container">
          <!-- Middle Sections -->
          <div class="footer-links">
            <div class="footer-column">
              <div class="footer-logo-box">
                <img
                 :src="appIcon || 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s'"

                  alt="logo"
                  class="footer-logo"
                />
                <p class="footer-company">{{ appName }}</p>
              </div>
              <p class="footer-company">{{ tagLine }}</p>
              <ul class="footer-contact">
                <li>
                  <i class="fas fa-map-marker-alt"></i>
                  Austin, Austin, Texas, 73301
                </li>
                <li>
                  <i class="fas fa-phone"></i>
                  (+1) 250-456-2966
                </li>
                <li>
                  <i class="fas fa-envelope"></i>
                  eshita90roy@gmail.com
                </li>
              </ul>
            </div>
            <div class="footer-column">
              <h4><i class="fas fa-user"></i> MY ACCOUNT</h4>
              <ul>
                <li><i class="fas fa-user"></i> My Account</li>
                <li><i class="fas fa-box"></i> Order History</li>
                <li><i class="fas fa-heart"></i> Wish List</li>
                <li><i class="fas fa-envelope-open-text"></i> Contact Us</li>
              </ul>
            </div>

            <div class="footer-column">
              <h4><i class="fas fa-question-circle"></i> HELP & SUPPORT</h4>
              <ul>
                <li><i class="fas fa-question"></i> FAQ</li>
                <li><i class="fas fa-file-alt"></i> Terms & Conditions</li>
                <li><i class="fas fa-lock"></i> Privacy Policy</li>
                <li><i class="fas fa-info-circle"></i> About Us</li>
              </ul>
            </div>

            <div class="footer-column">
              <h4><i class="fas fa-gamepad"></i>CATEGORIES</h4>
              <ul>
                <li><i class="fas fa-puzzle-piece"></i> Cleansers</li>
                <li><i class="fas fa-paper"></i>Face Masks</li>
                <li><i class="fas fa-cubes"></i> Building Sets</li>
                <li><i class="fas fa-paint-brush"></i>Lip Care</li>
                <li><i class="fas fa-child"></i>Moisturizer</li>
                <li><i class="fas fa-child"></i>Serum & Treatments</li>
              </ul>
            </div>
          </div>
        </div>
        <div class="footer-bottom">
          <p>
            © 2025 <span class="brand">{{ appName }}</span>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Note The icon need to be black for colour change to work

class Color {
  constructor(r, g, b) {
    this.set(r, g, b);
  }

  toString() {
    return `rgb(${Math.round(this.r)}, ${Math.round(this.g)}, ${Math.round(
      this.b
    )})`;
  }

  set(r, g, b) {
    this.r = this.clamp(r);
    this.g = this.clamp(g);
    this.b = this.clamp(b);
  }

  hueRotate(angle = 0) {
    angle = (angle / 180) * Math.PI;
    const sin = Math.sin(angle);
    const cos = Math.cos(angle);

    this.multiply([
      0.213 + cos * 0.787 - sin * 0.213,
      0.715 - cos * 0.715 - sin * 0.715,
      0.072 - cos * 0.072 + sin * 0.928,
      0.213 - cos * 0.213 + sin * 0.143,
      0.715 + cos * 0.285 + sin * 0.14,
      0.072 - cos * 0.072 - sin * 0.283,
      0.213 - cos * 0.213 - sin * 0.787,
      0.715 - cos * 0.715 + sin * 0.715,
      0.072 + cos * 0.928 + sin * 0.072,
    ]);
  }

  grayscale(value = 1) {
    this.multiply([
      0.2126 + 0.7874 * (1 - value),
      0.7152 - 0.7152 * (1 - value),
      0.0722 - 0.0722 * (1 - value),
      0.2126 - 0.2126 * (1 - value),
      0.7152 + 0.2848 * (1 - value),
      0.0722 - 0.0722 * (1 - value),
      0.2126 - 0.2126 * (1 - value),
      0.7152 - 0.7152 * (1 - value),
      0.0722 + 0.9278 * (1 - value),
    ]);
  }

  sepia(value = 1) {
    this.multiply([
      0.393 + 0.607 * (1 - value),
      0.769 - 0.769 * (1 - value),
      0.189 - 0.189 * (1 - value),
      0.349 - 0.349 * (1 - value),
      0.686 + 0.314 * (1 - value),
      0.168 - 0.168 * (1 - value),
      0.272 - 0.272 * (1 - value),
      0.534 - 0.534 * (1 - value),
      0.131 + 0.869 * (1 - value),
    ]);
  }

  saturate(value = 1) {
    this.multiply([
      0.213 + 0.787 * value,
      0.715 - 0.715 * value,
      0.072 - 0.072 * value,
      0.213 - 0.213 * value,
      0.715 + 0.285 * value,
      0.072 - 0.072 * value,
      0.213 - 0.213 * value,
      0.715 - 0.715 * value,
      0.072 + 0.928 * value,
    ]);
  }

  multiply(matrix) {
    const newR = this.clamp(
      this.r * matrix[0] + this.g * matrix[1] + this.b * matrix[2]
    );
    const newG = this.clamp(
      this.r * matrix[3] + this.g * matrix[4] + this.b * matrix[5]
    );
    const newB = this.clamp(
      this.r * matrix[6] + this.g * matrix[7] + this.b * matrix[8]
    );
    this.r = newR;
    this.g = newG;
    this.b = newB;
  }

  brightness(value = 1) {
    this.linear(value);
  }
  contrast(value = 1) {
    this.linear(value, -(0.5 * value) + 0.5);
  }

  linear(slope = 1, intercept = 0) {
    this.r = this.clamp(this.r * slope + intercept * 255);
    this.g = this.clamp(this.g * slope + intercept * 255);
    this.b = this.clamp(this.b * slope + intercept * 255);
  }

  invert(value = 1) {
    this.r = this.clamp((value + (this.r / 255) * (1 - 2 * value)) * 255);
    this.g = this.clamp((value + (this.g / 255) * (1 - 2 * value)) * 255);
    this.b = this.clamp((value + (this.b / 255) * (1 - 2 * value)) * 255);
  }

  hsl() {
    // Code taken from https://stackoverflow.com/a/9493060/2688027, licensed under CC BY-SA.
    const r = this.r / 255;
    const g = this.g / 255;
    const b = this.b / 255;
    const max = Math.max(r, g, b);
    const min = Math.min(r, g, b);
    let h,
      s,
      l = (max + min) / 2;

    if (max === min) {
      h = s = 0;
    } else {
      const d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;

        case g:
          h = (b - r) / d + 2;
          break;

        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }

    return {
      h: h * 100,
      s: s * 100,
      l: l * 100,
    };
  }

  clamp(value) {
    if (value > 255) {
      value = 255;
    } else if (value < 0) {
      value = 0;
    }
    return value;
  }
}

class Solver {
  constructor(target, baseColor) {
    this.target = target;
    this.targetHSL = target.hsl();
    this.reusedColor = new Color(0, 0, 0);
  }

  solve() {
    const result = this.solveNarrow(this.solveWide());
    return {
      values: result.values,
      loss: result.loss,
      filter: this.css(result.values),
    };
  }

  solveWide() {
    const A = 5;
    const c = 15;
    const a = [60, 180, 18000, 600, 1.2, 1.2];

    let best = { loss: Infinity };
    for (let i = 0; best.loss > 25 && i < 3; i++) {
      const initial = [50, 20, 3750, 50, 100, 100];
      const result = this.spsa(A, a, c, initial, 1000);
      if (result.loss < best.loss) {
        best = result;
      }
    }
    return best;
  }

  solveNarrow(wide) {
    const A = wide.loss;
    const c = 2;
    const A1 = A + 1;
    const a = [0.25 * A1, 0.25 * A1, A1, 0.25 * A1, 0.2 * A1, 0.2 * A1];
    return this.spsa(A, a, c, wide.values, 500);
  }

  spsa(A, a, c, values, iters) {
    const alpha = 1;
    const gamma = 0.16666666666666666;

    let best = null;
    let bestLoss = Infinity;
    const deltas = new Array(6);
    const highArgs = new Array(6);
    const lowArgs = new Array(6);

    for (let k = 0; k < iters; k++) {
      const ck = c / Math.pow(k + 1, gamma);
      for (let i = 0; i < 6; i++) {
        deltas[i] = Math.random() > 0.5 ? 1 : -1;
        highArgs[i] = values[i] + ck * deltas[i];
        lowArgs[i] = values[i] - ck * deltas[i];
      }

      const lossDiff = this.loss(highArgs) - this.loss(lowArgs);
      for (let i = 0; i < 6; i++) {
        const g = (lossDiff / (2 * ck)) * deltas[i];
        const ak = a[i] / Math.pow(A + k + 1, alpha);
        values[i] = fix(values[i] - ak * g, i);
      }

      const loss = this.loss(values);
      if (loss < bestLoss) {
        best = values.slice(0);
        bestLoss = loss;
      }
    }
    return { values: best, loss: bestLoss };

    function fix(value, idx) {
      let max = 100;
      if (idx === 2 /* saturate */) {
        max = 7500;
      } else if (idx === 4 /* brightness */ || idx === 5 /* contrast */) {
        max = 200;
      }

      if (idx === 3 /* hue-rotate */) {
        if (value > max) {
          value %= max;
        } else if (value < 0) {
          value = max + (value % max);
        }
      } else if (value < 0) {
        value = 0;
      } else if (value > max) {
        value = max;
      }
      return value;
    }
  }

  loss(filters) {
    // Argument is array of percentages.
    const color = this.reusedColor;
    color.set(0, 0, 0);

    color.invert(filters[0] / 100);
    color.sepia(filters[1] / 100);
    color.saturate(filters[2] / 100);
    color.hueRotate(filters[3] * 3.6);
    color.brightness(filters[4] / 100);
    color.contrast(filters[5] / 100);

    const colorHSL = color.hsl();
    return (
      Math.abs(color.r - this.target.r) +
      Math.abs(color.g - this.target.g) +
      Math.abs(color.b - this.target.b) +
      Math.abs(colorHSL.h - this.targetHSL.h) +
      Math.abs(colorHSL.s - this.targetHSL.s) +
      Math.abs(colorHSL.l - this.targetHSL.l)
    );
  }

  css(filters) {
    function fmt(idx, multiplier = 1) {
      return Math.round(filters[idx] * multiplier);
    }
    return `filter: invert(${fmt(0)}%) sepia(${fmt(1)}%) saturate(${fmt(
      2
    )}%) hue-rotate(${fmt(3, 3.6)}deg) brightness(${fmt(4)}%) contrast(${fmt(
      5
    )}%);`;
  }
}

export default {
  data() {
    return {
      categories: [
        {
          title: "Cleansers",
          desc: "Discover amazing cleansers products",
          image:"https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
        },
        {
          title: "Face Masks",
          desc: "Discover amazing face masks products",
          image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
        },
        {
          title: "Lip Care",
          desc: "Discover amazing lip care products",
          image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
        },
        {
          title: "Moisturizer",
          desc: "Discover amazing moisturizer products",
          image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
        },
        {
          title: "Serums & Treatments",
          desc: "Discover amazing serums & treatments products",
          image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
        },
        {
          title: "Toner",
          desc: "Discover amazing toner products",
          image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
        },
      ],
      products: [
        {
          name: "Serum",
          brand: "GlowingBeauty",
          image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
          price: 200,
          oldPrice: 250,
          discount: 26,
        },
        {
          name: "Clean & Care",
          brand: "GlowingBeauty",
          image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
          price: 19,
          oldPrice: 23,
          discount: 18,
        },
        {
          name: "Lip Balm",
          brand: "GlowingBeauty",
          image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
          price: 155,
          oldPrice: 181,
          discount: 14,
        },
        {
          name: "Face Wash",
          brand: "GlowingBeauty",
          image: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSmMFUr4TWHqkYckkiJqqEqBFqYy9gQKQ7N3w&s",
          price: 99,
        },
      ],
    };
  },
  props: {
    font: {
      type: String,
      default: "",
    },
    tagLine: {
      type: String,
      default: "Turn on your natural glow",
    },
    primaryColor: {
      type: String,
      default: "#ffffff",
    },
    primaryTextColor: {
      type: String,
      default: "#000000",
    },
    primaryLightColor: {
      type: String,
      default: "#ffffff",
    },
    statusBar: {
      type: String,
      default: "#ffffff",
    },
    headerTop: {
      type: String,
      default: "#ffffff",
    },
    headerBottom: {
      type: String,
      default: "#ffffff",
    },
    headerFont: {
      type: String,
      default: "#ffffff",
    },
    footerBgColor: {
      type: String,
      default: "#ffffff",
    },
    footerTextColor: {
      type: String,
      default: "#ffffff",
    },
    appIcon: {
      type: String,
      default: null,
    },
    appName: {
      type: String,
      default: "Glowify",
    },
    btnColour: {
      type: String,
      default: "#0b4990",
    },
    headerCartIcon: {
      type: Boolean,
      default: true,
    },
    headerWishlistIcon: {
      type: Boolean,
      default: true,
    },
    headerNavs: {
      type: Boolean,
      default: true,
    },
    businessKeyPoints: {
      type: Boolean,
      default: true,
    },
    categorySection: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    hexToRgb(hex) {
      // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
      const shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
      hex = hex.replace(shorthandRegex, (m, r, g, b) => {
        return r + r + g + g + b + b;
      });

      const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
      return result
        ? [
            parseInt(result[1], 16),
            parseInt(result[2], 16),
            parseInt(result[3], 16),
          ]
        : null;
    },
    changeToColor(col) {
      const rgb = this.hexToRgb(col);

      const color = new Color(rgb[0], rgb[1], rgb[2]);
      const solver = new Solver(color);
      const result = solver.solve();
      return result.filter;
    },

    //based on the button background hex color, calculate the luminance/ brightness of the color
    getLuminance(hexColor) {
      const rgb = this.hexToRgb(hexColor);
      if (!rgb) return 0;

      // Calculate relative luminance using WCAG formula
      const [r, g, b] = rgb.map((c) => {
        c = c / 255;
        return c <= 0.03928 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
      });
      return 0.2126 * r + 0.7152 * g + 0.0722 * b;
    },
  },
  computed: {
    buttonTextColor() {
      const luminance = this.getLuminance(this.btnColour);
      return luminance > 0.5 ? "#000000" : "#ffffff";
    },
    buttonStyle() {
      return {
        "--btn-color": this.btnColour,
        "--btn-text-color": this.buttonTextColor,
        "--primary-color": this.primaryColor,
        "--secondary-color": this.headerTop,
        "--primary-light-color": this.primaryLightColor,
        "--primary-text-color": this.primaryTextColor,
        "--footer-bg-color": this.footerBgColor,
        "--footer-text-color": this.footerTextColor,
      };
    },
    headerIconStyle() {
      return this.changeToColor(this.primaryTextColor);
    },
    // footerNormalStyle() {
    //   return this.changeToColor(this.footerNormal);
    // },
    // footerSelStyle() {
    //   return this.changeToColor(this.footerSelection);
    // },
    splashBGStyle() {
      if (this.splashBGImage) {
        return `background-image:url(${this.splashBGImage});background-color:${this.splashBGCol};`;
      }
      return `background:${this.splashBGCol};`;
    },
  },
  mounted() {
    this.changeToColor("#aa44bb");
  },
};
</script>

<style lang="scss" scoped>
.app-name {
  font-size: 12x;
}
.tag-line {
  font-size: 7px;
}
.icon-gap {
  padding-left: 3px;
}
.badge {
  padding: 6px 16px;
  border-radius: 999px;
  display: inline-block;
  font-weight: bold;
}
.banner-text {
  max-width: 80%;
}
.banner-text h1 {
  font-size: 48px;
  font-weight: 700;
  line-height: 1.2;
  margin-bottom: 20px;
}

.banner-text p {
  font-size: 16px;
  line-height: 1.6;
  margin-top: 10px;
}

.banner-text .highlight {
  color: #004aad;
}
.search-bar {
  border: 1px solid var(--primary-light-color); /* Default border color */
  display: flex;
  align-items: center;
  border-radius: 50px;
  padding: 2px;

  &:hover {
    border-color: var(--primary-color); /* Change border color on hover */
    box-shadow: 0 0 8px var(--primary-light-color); /* Optional: Add a shadow effect */
  }
}

.search-bar input {
  flex: 1;
  border: none;
  background: transparent;
  outline: none;
  font-size: 7px;
}

.search-bar button {
  border: none;
  height: 18px;
  width: 18px;
  border-radius: 20px;
  cursor: pointer;
  background: var(--primary-color);
  color: var(--btn-text-color);

  &:hover {
    background: var(--primary-light-color);
  }
}
.banner-img {
  height: 130px;
  border-radius: 10px;
}
.category-section {
  // background: #e8b29c;
  padding: 10px;
  text-align: center;
}

/* Heading */
.section-header h2 {
  font-size: 14px;
  font-weight: 700;
  margin-bottom: 4px;
}

.section-header p {
  font-size: 10px;
  margin-bottom: 14px;
}

/* Grid */
.category-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 10px;
  max-width: 1200px;
  margin: 0 auto;
}

/* Card */
.category-card {
  background: var(--primary-color);
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  transition: transform 0.3s;
}

.category-card:hover {
  transform: translateY(-6px);
  background: var(--primary-light-color);
}
.category-card:hover .card-top img {
  opacity: 1;
}

/* Top Gradient */
.card-top {
  position: relative;
  height: 120px;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
  background: linear-gradient(135deg, #147d58, #2c4da8);
  padding: 10px;
  display: flex;
  align-items: flex-start;
}

/* Icon always visible */
.card-top .card-icon {
  font-size: 24px;
  z-index: 2;
  position: relative;
  color: #fff;
}

/* Hover Image */
.card-top img {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.4s ease-in-out; /* smooth zoom */
  z-index: 1; /* image stays behind icon */
}

.category-card:hover .card-top img {
  transform: scale(1.1); /* zoom in */
}

/* Content */
.card-content {
  padding: 0px 10px 10px 10px;
  text-align: left;
}

.card-content h3 {
  font-size: 12px;
  font-weight: bold;
  margin-bottom: 8px;
}

.card-content p {
  font-size: 9px;
  margin-bottom: 12px;
}

.shop-link {
  font-size: 9px;
  font-weight: 600;
  text-decoration: none;
}

.shop-link:hover {
  text-decoration: underline;
}
.trending-section {
  padding: 10px;

  .trending-header {
    text-align: left;
    margin-bottom: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .badge {
      background: linear-gradient(
        90deg,
        var(--primary-color),
        var(--secondary-color)
      );
      padding: 6px 14px;
      border-radius: 20px;
      font-weight: bold;
      display: inline-block;
    }

    h2 {
      font-size: 16px;
      font-weight: 700;
    }

    .view-all {
      background: var(--primary-color);
      border: none;
      border-radius: 20px;
      padding: 8px 16px;
      cursor: pointer;
      font-weight: bold;

      &:hover {
        background: var(--primary-light-color);
        box-shadow: 0 0 8px var(--primary-light-color);
      }
    }
  }

  .product-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;

    .product-card {
      border-radius: 16px;
      padding: 16px;
      position: relative;
      overflow: hidden;
      box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
      transition: transform 0.3s;
      .discount-badge {
        position: absolute;
        top: 10px;
        left: 10px;
        background: var(--primary-light-color);
        font-size: 12px;
        padding: 4px 8px;
        border-radius: 8px;
        font-weight: bold;
      }

      .actions {
        position: absolute;
        top: 10px;
        right: 10px;
        display: flex;
        flex-direction: column;
        gap: 8px;

        .circle-btn {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          font-size: 14px;
          box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);

          &.white {
            background: #fff;
            color: #000;
          }
          &.green {
            background: #06b06d;
            color: #fff;
          }
        }
      }

      .product-image {
        text-align: center;
        margin-bottom: 16px;

        img {
          max-height: 140px;
          object-fit: contain;
        }
      }

      .product-info {
        h3 {
          font-size: 16px;
          margin: 0;
        }
        .brand {
          font-size: 13px;
        }
        .price {
          margin: 10px 0;
          .old-price {
            text-decoration: line-through;
            margin-right: 8px;
          }
          .new-price {
            font-weight: bold;
          }
        }
        .add-to-bag {
          background: var(--primary-color);
          border: none;
          width: 100%;
          padding: 8px 0;
          border-radius: 10px;
          font-weight: bold;
          cursor: pointer;

          &:hover {
            background: var(--primary-light-color);
            box-shadow: 0 0 8px var(--primary-light-color);
          }
        }
      }
    }
    .product-card:hover {
      transform: translateY(-6px);
      box-shadow: 0 0 8px var(--primary-light-color);
    }
  }
}
.favorite-brands h2 {
  text-align: center;
  font-size: 16px;
  padding-bottom: 10px;
}
.mid-banner {
  max-height: 230px;
  width: 100%;
  overflow: hidden;
}

.mid-banner img {
  width: 100%;
  height: 100%;
  object-fit: cover; /* makes image fill the box */
  display: block;
}
.laptop-body {
  width: 500px;
  height: 290px;
  background: white;
  position: relative;
  z-index: 10;
  font-size: 10px;
  overflow-y: auto; // Changed from overflow: hidden
  overflow-x: hidden; // Prevent horizontal scrolling
}

.header-mob {
  width: 100%;
  height: 40px;
  border-radius: 0;
  display: flex;
  align-items: center;
  justify-content: space-around;
  box-shadow: 0px 2.2637px 5.65925px rgba(0, 0, 0, 0.15);
}

// .filter-bar {
//   margin: 5px 10px;
//   color: #979797;
//   font-size: 6px;
// }

// .search-bar-large {
//   width: 120px;
//   padding: 2px 5px;
//   background: white;
//   vertical-align: middle;
//   border-radius: 10px;
//   display: inline-block;
//   border: 1px solid gray;
// }

.laptop-frame {
  position: absolute;
  z-index: 2;
  bottom: -59px;
  left: -122.5px;

  img {
    display: block;
    width: 745px;
    height: 358px;
    object-fit: fill;
  }
}

.app-logo {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: bold;
  font-size: 12px;

  img {
    width: 25px;
  }
}

.advertisement {
  position: relative;
}

/* identical to box height */
.laptop-body::-webkit-scrollbar {
  width: 6px;
}

.laptop-body::-webkit-scrollbar-track {
  background: #f1f1f1;
}

.laptop-body::-webkit-scrollbar-thumb {
  background: #888;
  border-radius: 3px;
}

.laptop-body::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.headerUl {
  display: inline-block;
  display: flex;
  padding: 0;
  font-size: 2px;
  list-style: outside none;
  align-items: center;
  margin-bottom: 0;
}
.headerUl li {
  margin: 0 4px;
  color: var(--primary-text-color);
  &:hover {
    color: var(--primary-light-color);
  }
}
.headerUl h5 {
  font-size: 10px;
  margin: 0;
}
.headerUl i {
  font-size: 10px;
}

.shippingArea img {
  width: 20px;
}
.shippingArea h1 {
  font-size: 9px;
  margin-bottom: 0;
}
.shippingArea p {
  font-size: 8px;
}

.footer-container {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-top: 1rem;
}
.footer-logo-box {
  display: flex;
  align-items: center;
}
.footer-logo {
  width: 40px;
  margin-bottom: 10px;
  margin-right: 10px;
}
.footer-company {
  color: #ff7f50;
  font-weight: bold;
  margin-bottom: 15px;
}
.footer-contact li {
  margin: 6px 0;
  list-style: none;
}
.footer-contact i {
  margin-right: 8px;
  color: #ff6b57;
}

.footer-links {
  flex: 2;
  display: flex;
  justify-content: space-around;
  flex-wrap: wrap;
}
.footer-column {
  margin: 2px;
}
.footer-column h4 {
  font-size: 12px;
  font-weight: bold;
  color: #ff7f50;
  margin-bottom: 10px;
}
.footer-column ul {
  padding: 0;
}
.footer-column li {
  list-style: none;
  margin: 6px 0;
  cursor: pointer;
  transition: 0.2s;
}
.footer-column li i {
  margin-right: 6px;
  color: #ff9966;
}
.footer-column li:hover {
  color: #ff5722;
}

.footer-bottom {
  text-align: center;
  font-size: 14px;
  border-top: 1px solid #f5dcdc;
  margin-top: 20px;
  padding: 10px 0;
}
</style>
